import { clearingApi } from "../config/apiConfig";

// GET all DATEV export registry rows for a year (drives the grid + polling).
export const listExports = async (year) => {
  const response = await clearingApi.get("backoffice/datev/exports", { params: { year } });
  return response.data;
};

// POST to generate (sync for revenues/payments, async dispatch for receipts).
// payload: { year, month, source, kind, debtorAccount?, revenueAccount?, bankAccount?, stripeFeesAccount? }
export const generateExport = async (payload) => {
  const response = await clearingApi.post("backoffice/datev/exports/generate", payload);
  return response.data;
};

// GET a short-lived presigned S3 download URL for a generated export.
export const getExportDownloadUrl = async (exportId) => {
  const response = await clearingApi.get(`backoffice/datev/exports/${exportId}/download`);
  return response.data.url;
};
